import CONSTANTS from './constants';
import { getRuntimeEnv } from './environment';

const isProductionEnv = () => getRuntimeEnv() === CONSTANTS.ENV.PRODUCTION;


export function getSegmentKey() {
    if (isProductionEnv()) {
        console.log(process.env.NODE_ENV, 'prod-segment');
        return CONSTANTS.INTEGRATION.SEGMENT_KEY_LIVE;
    }

    console.log(process.env.NODE_ENV, 'dev-segment');
    return CONSTANTS.INTEGRATION.SEGMENT_KEY_TEST;
}

export function getHelloSignKey() {
    if (isProductionEnv()) {
        console.log(process.env.NODE_ENV, 'prod-hellosign');
        return CONSTANTS.INTEGRATION.HELLO_SIGN_CLIENT_ID;
    }

    console.log(process.env.NODE_ENV, 'dev-hellosign');
    return CONSTANTS.INTEGRATION.HELLO_SIGN_CLIENT_ID_TEST;
}

export function getSentryKey() {                                                                                                                                                                                                                                                                                                                      
    console.log(process.env.NODE_ENV, 'sentry');
    return CONSTANTS.INTEGRATION.SENTRY_KEY;
}

export function getCannyAppId() {
    if (isProductionEnv()) {
        return CONSTANTS.INTEGRATION.CANNY_APP_ID_LIVE;
    }

    return CONSTANTS.INTEGRATION.CANNY_APP_ID_TEST;
}


export function getCannyBoardToken() {
    if (isProductionEnv()) {
        return CONSTANTS.INTEGRATION.CANNY_BOARD_TOKEN_LIVE;
    }

    return CONSTANTS.INTEGRATION.CANNY_BOARD_TOKEN_TEST;
}